import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const WashingMachine = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      {...rest}
      fill={fill}
    >
      <path
        d="M6.17 8.65a3.222 3.222 0 0 1 2.11.543 2.557 2.557 0 0 0 3.15-.216l.446.495a3.224 3.224 0 0 1-3.97.273m0 0a2.556 2.556 0 0 0-3.238.303l-.47-.473a3.222 3.222 0 0 1 1.972-.924"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M1.666.637h12.666v15.332H1.666V.637Zm.667.666v14h11.333v-14H2.333Z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M8 5.637a3.333 3.333 0 1 0 0 6.667 3.333 3.333 0 0 0 0-6.667ZM4 8.971a4 4 0 1 1 8 0 4 4 0 0 1-8 0ZM3.666 2.637h3v.666h-3v-.666Z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path d="M9.333 3.636a.667.667 0 1 0 0-1.333.667.667 0 0 0 0 1.333ZM11.667 3.636a.667.667 0 1 0 0-1.333.667.667 0 0 0 0 1.333Z" />
    </svg>
  );
};

WashingMachine.category = 'product-category';

WashingMachine.displayName = 'WashingMachine';
